import "./Theme.css";

export default {
  code: "editor-code",
  heading: {
    h1: "editor-heading-h1 headings",
    h2: "editor-heading-h2 headings",
    h3: "editor-heading-h3 headings",
    h4: "editor-heading-h4 headings",
    h5: "editor-heading-h5 headings",
    h6: "editor-heading-h6 headings",
  },
  image: "editor-image",
  link: "editor-link",
  list: {
    listitem: "editor-listitem",
    nested: {
      listitem: "editor-nested-listitem",
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
  },
  tableCell: "editor-table-cell",
  tableCellSelected: "editor-table-cell-selected",
  tableScrollableWrapper: "tableScrollableWrapper",
  ltr: "ltr",
  paragraph: "editor-paragraph",
  placeholder: "editor-placeholder",
  quote: "editor-quote",
  rtl: "rtl",
  text: {
    bold: "editor-text-bold",
    code: "editor-text-code",
    hashtag: "editor-text-hashtag",
    italic: "editor-text-italic",
    overflowed: "editor-text-overflowed",
    strikethrough: "editor-text-strikethrough",
    underline: "editor-text-underline",
    underlineStrikethrough: "editor-text-underlineStrikethrough",
  },
};
